import { html, css, LitElement } from '../../../../../jb-nexus/node_modules/lit';
import { NexusComponent } from './nexus.component';
import { SearchAutoCompleteModule } from "../modules/search-autocomplete.module";
import * as bootstrap from 'bootstrap';
import { DebounceModule } from './debounce.module';
import { LineClampModule } from './line-clamp.module';
import { DocumentLanguageModule } from './document-language.module';
// import { TextToSpeechModule } from './text-to-speech.module';
import { StateMachineModule } from './state-machine.module';

export class NexusSearchComponent extends NexusComponent {

    debounceModule = new DebounceModule();
    debugMode = true;

    dropdowns = [];
    collapses = [];

    showEmptyMessage = false;

    requestPipeLine = [];
    cachedInputLength = 0;

    fetchDebounceTime = 500;

    maximumSmolSearchResults = 3;

    currentInputValue = null;

    backgroundIdentifier = 'tertiary-darker';

    stateMachineModule = new StateMachineModule();

    loadingState = null;

    takeOverState = 'inactive';

    uri = '';

    static properties = {
        title: {
            type: String,
            attribute: true,
        },
        themeId: {
            type: String,
            attribute: true,
            reactive: true,
        },
        query: {
            type: Boolean,
            attribute: true,
            reactive: true,
        },
        flow: {
            type: String,
            attribute: true,
            reactive: true,
        },
        theme: {
            attribute: 'theme',
            reflect: true,
        },
        searchMenuIdentifier: {
            type: String,
            reactive: true,
            attribute: 'identifier'
        },
        placement: {
            type: String,
            attribute: true,
            reactive: true,
        },
        backgroundIdentifier: {
            type: String,
            reactive: true,
            attribute: 'background'

        },
        data: {

        },
        results: {

        },
        dropdownState: {
            type: String,
            reactive: true,
        },
        collapseState: {
            type: String,
            reactive: true,
        }
    }

    term = null;
    cachedLink = null;
    searchEndPoint = null;
    domParser = this.createDomParser();
    minimumInputValueLength = 3;
    fetchedEndPointData = false;
    searchMenuIdentifier = null;
    dropdownState = null;
    collapseState = null;
    query = false;
    handleSlotChange(event) {
        const childNodes = event.target.assignedNodes({ flatten: true });
        console.log('[NexusSearchComponent] handleSlotChange', event, childNodes);
    }

    // get _slottedChildren() {
    //     const slot = this.querySelector('slot');
    //     console.log('[NexusSearchComponent] _slottedChildren', slot);
    //     return slot.assignedElements({ flatten: true });
    // }

    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: block;  /* or display: flex; */
            position: relative;
            margin: 0;
			}
		`;
    }
    constructor() {
        super();
        this.title = null;
        this.themeId = null;
        this.theme;
        this.data = {};
        this.uri = '';
        this.flow = null; // desktop or mobile
        this.placement = null;
        this.searchMenuIdentifier = `search-menu-${(Math.random() * 10).toFixed(0)}`;
        this.setRoot(this);
        this.dropdownState = null;
        this.collapseState = null;
        this.query = false;
        this.backgroundIdentifier = 'tertiary-darker';
        console.log('[NexusSearchComponent] constructing');
    }


    // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {
        // console.log('updated this._slottedChildren', this._slottedChildren);
        this.lineClampModule.initialize();
    }

    doRender() {
        console.log('search...');
        let result = html``;
        result = html`
            <div component-loaded>
                    ${this.renderComponentBasedOnFlow()}
            </div>
        `;
        return result;
    }


    renderComponentBasedOnFlow() {
        let template = html``;
        if (this.flow == 'dropdown') {
            template = html`
            <div class="input-group col-12 col-sm-6 col-lg-4 mb-2 mb-sm-0">
                ${this.renderInput()}
                ${this.renderSearchResultElement()}
            </div>
        `;
        }
        if (this.flow == 'collapse') {
            template = html`
            <div class="input-group col-12 col-sm-6 col-lg-4 mb-2 mb-sm-0">
                ${this.renderInput()}
            </div>
            <div class="input-group">
                ${this.renderSearchResultElement()}
            </div>
        `;
        }
        return template;
    }

    handleClick(event) {
        // this.renderRoot.classList.add('wide');
    }


    renderGoBackButton() {
        // console.log('renderGoBackButton', this.dropdownState);
        let template = html``;
        if (this.dropdownState == 'shown' || this.collapseState == 'shown') {
            template = html`
            <button @click="${this.handleGoBackButtonClick}" class="btn btn-${this.backgroundIdentifier} btn-action-back" type="button">
                <svg class="icon-arrow-left svg-icon svg-icon-hover svg-icon-size-20">
                    <title>Pijl naar links icoon</title>
                    <use xlink:href="#icon-arrow-left"></use>
                </svg>
            </button>
            `;
        }
        return template;
    }

    handleGoCloseButtonClick(event) {
        let searchInput = this.renderRoot.querySelector('.form-control-search');
        if (searchInput) {
            searchInput.value = '';
            this.data = {};
        }
        this.collapses.forEach((collapse) => {
            collapse.hide();
            searchInput.focus();
        });
        this.dropdowns.forEach((dropdown) => {
            dropdown.hide();
            searchInput.focus();
        });
        // searchInput.placeholder = 'Ga verder met je zoektocht...';
        // this.requestUpdate();
        this.handleTakeOverState('inactive');
    }


    handleGoBackButtonClick(event) {
        let searchInput = this.renderRoot.querySelector('.form-control-search');
        this.collapses.forEach((collapse) => {
            collapse.hide();
            // searchInput.focus();
        });
        this.dropdowns.forEach((dropdown) => {
            dropdown.hide();
            // searchInput.focus();
        });
        // this.requestUpdate();
        this.handleTakeOverState('inactive');
        searchInput.value = '';

    }

    renderGoCloseButton() {
        // console.log('renderGoCloseButton', this.dropdownState);
        let template = html``;
        if (this.dropdownState == 'shown' || this.collapseState == 'shown') {
            template = html`
            <button @click="${this.handleGoCloseButtonClick}" class="btn btn-${this.backgroundIdentifier} btn-action-close search-close-button" type="button">
                <svg class="icon-close svg-icon svg-icon-hover svg-icon-size-40">
                    <title>Close icon</title>
                    <use xlink:href="#icon-close"></use>
                </svg>
            </button> 
            `;
        }
        return template;
    }

    getCollapseToggleValue() {
        let template = ``;
        if (this.flow === 'collapse') {
            template = `collapse`;
        }
        if (this.flow === 'collapse' && this.placement == 'main') {
            template = ``;
        }
        return template;
    }

    getDropdownToggleValue() {
        let template = ``;
        if (this.flow === 'dropdown' && this.currentInputValue && this.currentInputValue.length > 0) {
            template = `dropdown`;
        }
        return template;
    }

    renderInput() {
        let template = html``;

        if (this.flow == 'collapse') {
            template = html`
            ${this.renderGoBackButton()}
            <input
            @click="${this.handleClick}"
            @input="${this.handleInput}"
            @blur="${this.handleInputBlur}"
            @focus="${this.handleInputFocus}"
            
            
            type="text"
            .title=${this.getTemplateContentForAttribute('translate-placeholder-initial')}
            alt="Zoekbalk"
            name="s"
            class="form-control form-control-sm form-control-search bg-${this.backgroundIdentifier}"
            data-bs-target="#${this.searchMenuIdentifier}"
            .value=${this.term}
            .placeholder=${this.getTemplateContentForAttribute('translate-placeholder-initial')}
            autocomplete="off"
            data-action="search" />
            
            <button class="btn btn-search btn-${this.backgroundIdentifier}" title="Zoeken" type="submit">
                <svg class="svg-icon svg-icon-hover svg-icon-size-40 static-color">
                    <title>Search icon</title>
                    <use xlink:href="#icon-search"></use>
                </svg>
            </button>
        `;
        }

        if (this.flow == 'dropdown') {
            template = html`
                <input
                    @click="${this.handleClick}"
                    @input="${this.handleInput}"
                    @blur="${this.handleInputBlurDropDown}"
                    @focus="${this.handleInputFocusDropdown}"
                    type="text"
                    .title=${this.getTemplateContentForAttribute('translate-placeholder-initial')}
                    alt="Zoekbalk"
                    name="s"
                    class="form-control form-control-sm form-control-search dropdown-toggle bg-${this.backgroundIdentifier}"
                    .value=${this.term}
                    .placeholder=${this.getTemplateContentForAttribute('translate-placeholder-initial')}
                    autocomplete="off"
                    data-action="search"
                    
                />
                ${this.renderGoCloseButton()}
                <button class="btn btn-search btn-${this.backgroundIdentifier}" title="Zoeken" type="submit">
                    <svg class="svg-icon svg-icon-hover svg-icon-size-40">
                        <title>Search icon</title>
                        <use xlink:href="#icon-search"></use>
                    </svg>
                </button>

        `;
        }

        return template;
    }

    handleInputBlur(event) {
        this.collapses.forEach((collapse) => {
            console.log('blur -- collapse', collapse);
            // collapse.hide();
        });
        // this.dropdowns.forEach((dropdown) => {
        //     console.log('blur -- dropdown', dropdown);
        //     dropdown.hide();
        // });
        this.renderRoot.classList.remove('wide');
    }

    handleInputFocus(event) {
        this.renderRoot.classList.add('wide');
    }

    handleInputBlurDropDown(event) {
        // if (this.currentInputValue && this.currentInputValue.length === 0) {
        this.renderRoot.classList.remove('wide');
        // }
    }

    handleInputFocusDropdown(event) {
        // if (this.currentInputValue && this.currentInputValue.length === 0) {
        this.renderRoot.classList.add('wide');
        if (event.target.value.length > 0) {
            this.dropdowns.forEach((dropdown) => {
                console.log('focus -- dropdown', dropdown);
                dropdown.show();
                this.handleSearchFetch(event);
            });
        }
        // }
    }


    renderSearchResultElementClasses() {
        let classes = [
        ];
        if (this.flow === 'dropdown') {
            classes.push('dropdown-menu');
            classes.push('bg-tertiary');
            classes.push('mt-2');
        }
        if (this.flow === 'collapse' && this.placement == 'main') {
            classes.push('list-unstyled');
            classes.push('w-100');

        }
        if (this.flow === 'collapse' && this.placement == 'nav') {
            classes.push('collapse');
            classes.push('list-unstyled');
            classes.push('bg-tertiary');
            classes.push('mt-2');
        }
        return classes.join(' '); // append to string
    }

    renderSearchResultElement() {
        return html`
            <ul id="${this.searchMenuIdentifier}" class="${this.renderSearchResultElementClasses()}">
                ${this.renderSearchResultItems()}
                ${this.showEmptyMessageIfNoResults()}
                ${this.renderLoadingPlaceholder()}
                ${this.renderAllResultsListItem()}
            </ul>
        `;
    }

    renderLoadingPlaceholder() {
        let template = html``;
        if (
            this.data
            && typeof this.data.results == 'undefined'
            && this.placement == 'nav'
        ) {
            template = html`
            <li class="row">
                <div class="col-12 px-4">
                    <div class="row">
                        <div class="col-auto d-flex justify-content-center align-self-center">
                            <div class="spinner-border" role="status"></div>
                        </div>
                        <div class="col-8">
                            ${this.getTemplateContent('translate-loading-results-for-search-term')}
                        </div>
                    </div>
                </div>
            </li>
            `;
        }
        return template;
    }

    /**
     * 
     * @returns 
     */
    renderAllResultsListItem() {
        if (
            this.placement == 'nav' &&
            this.data &&
            this.data.results &&
            // this.data.results.length > this.maximumSmolSearchResults &&
            this.currentInputValue &&
            this.currentInputValue.length > 0
        ) {
            return html`
            <li class="row">
                <a href="${this.uri}/?s=${this.currentInputValue}" class="col col-12 pb-4 search-result-small">
                    <div class="row">
                        <div class="col hyphenate text-decoration-underline">
                            ${this.getTemplateContent('translate-search-results-small-more-results')}
                        </div>
                        <div class="col ms-auto col-auto my-auto">
                            <svg class="icon-arrow-right static-color svg-icon svg-icon-size-20">
                                <title>Arrow right icon</title>
                                <use xlink:href="#icon-arrow-right"></use>
                            </svg>
                        </div>
                    </div>
                </a>
            </li>
            `;
        } else {
            return html``; // nothing
        }
    }

    showEmptyMessageIfNoResults() {
        if (
            this.currentInputValue &&
            this.currentInputValue.length > 0 &&
            this.data &&
            typeof this.data.results !== 'undefined' &&
            this.data.results.length == 0
        ) {
            return html`
            <li class="row">
                <div class="col col-12 search-result-small pb-4">
                ${this.getTemplateContent('translate-no-results-for-search-term')}
                </div>
            </li> 
            `;
        }
        return html``;
    }

    // showMessageIfDataIsNull() {
    //     if (
    //         this.data == null
    //     ) {
    //         return html`
    //         <li class="row">
    //             <div class="col col-12 search-result-small pb-4">
    //                 We gaan opnieuw zoeken
    //             </div>
    //         </li> 
    //         `;
    //     }
    //     return html``;
    // }

    getSearchResultsAmountText() {
        let template = html``;
        if (this.data.results.length < 2) {
            template = html`${this.getTemplateContent('translate-singular-results-found')}`;
        }
        if (this.data.results.length > 1) {
            template = html`${this.getTemplateContent('translate-plural-results-found')}`;
        }
        return template;
    }


    renderSearchResultItems() {
        // console.log('renderSearchResultItems', this.data, this.data.results);
        let items = [
        ];

        if (this.data && this.data.results) {
            if (this.placement == 'nav') {
                let slicedResults = this.data.results.slice(0, this.maximumSmolSearchResults);
                slicedResults.forEach((result) => {
                    items.push(this.renderSearchResultItemSmol(result));
                });
            }
            if (this.placement === 'main') {
                items.push(html`
                    <li class="row">
                        <div class="col my-4">
                            <smol>
                                <small>
                                    ${this.data.results.length} ${this.getSearchResultsAmountText()}
                                </small>
                            </smol>
                        </div>
                    </li>
                        `);
                this.data.results.forEach((result) => {
                    items.push(this.renderSearchResultItemChonk(result));
                });
            }
            if (
                this.placement == 'nav' &&
                this.data.results.length > this.maximumSmolSearchResults
            ) {
                items.push(html`
                    <li class="row">
                        <div class="col search-result-small pb-4">
                            ${this.data.results.length} ${this.getSearchResultsAmountText()}
                        </div>
                    </li>
                    `);
            }
        }

        return items;

    }

    handleTakeOverState(takeOverState) {
        let closestMainNavigationContainer = this.renderRoot.closest('.main-navigation-container');
        if (closestMainNavigationContainer) {
            let visibleClasses = [
                'd-block',
                'd-xl-block',
            ];
            let invisibleClasses = [
                'd-none',
                'd-xl-block',
            ];
            let elements = closestMainNavigationContainer.querySelectorAll('.search-take-over-switchable');

            switch (takeOverState) {
                case 'active':
                    elements.forEach(element => {
                        if (element) {
                            visibleClasses.forEach((_class) => {
                                element.classList.remove(_class);
                            });
                        }
                    });
                    elements.forEach(element => {
                        if (element) {
                            invisibleClasses.forEach((_class) => {
                                element.classList.add(_class);
                            });
                        }
                    });
                    break;

                case 'inactive':
                    elements.forEach(element => {
                        if (element) {
                            visibleClasses.forEach((_class) => {
                                element.classList.add(_class);
                            });
                        }
                    });
                    elements.forEach(element => {
                        if (element) {
                            invisibleClasses.forEach((_class) => {
                                element.classList.remove(_class);
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
            this.takeOverState = takeOverState;

        }
    }

    handleInput(input) {
        console.log('handleInput', input.target.value.length);
        this.cachedInputLength = input.target.value.length;
        this.currentInputValue = input.target.value;
        this.returnedSearchResults = false;
        if (this.cachedInputLength > 0) {
            if (this.flow == 'collapse') {
                this.collapses.forEach((collapse) => {
                    console.log('focus -- collapse', collapse);
                    collapse.show();
                });
                this.handleTakeOverState('active');
            }
            if (this.flow === 'dropdown') {
                this.dropdowns.forEach((dropdown) => {
                    console.log('focus -- dropdown', dropdown);
                    dropdown.show();
                });

            }
        }
        // if (event.target.value.length >= this.minimumInputValueLength) {
        this.debounceModule.debounce2(this.handleSearchFetch, this.fetchDebounceTime, [input], this);
        // console.log(`minimum of ${this.minimumInputValueLength} reached`);
        // }
        this.renderRoot.addEventListener('mouseover', (event) => {
            // let t = new TextToSpeechModule();
            // t.initialize();
            // if (t.enabled) {
            //     t.speak(`Invoer herkend. De waarde is nu ${event.target.value}`);
            // }
        });
    }

    handleSearchFetch(event) {
        console.log('handleSearchFetch', event.target.value.length, this.cachedInputLength);
        let data = {

        };
        let f = document.createElement('form');
        let formData = new FormData(f);
        formData.set('s', event.target.value);
        let formObject = Object.fromEntries(formData);
        formObject = Object.assign(formObject, data);

        this.requestPipeLine.push({
            value: event.target.value,
        });

        if (event.target.value.length > 0) {
            if (this.syncResultSlot) {
                this.syncResultSlot.classList.add('d-none'); // hide
            }

            fetch(
                this.searchEndPoint,
                {
                    method: 'POST',
                    body: new URLSearchParams(formData), // as form fields in request header
                    redirect: 'follow',
                }
            ).then((result) => {
                if (this.flow == 'dropdown') {
                    this.dropdowns.forEach((dropdown) => {
                        console.log('dropdown show', dropdown);
                        dropdown.show();
                        // force show, this kinda overrides the dropdown behavior of toggling.
                        // Show what the results are while typing
                    });
                }
                if (this.flow == 'collapse') {
                    this.collapses.forEach((collapse) => {
                        console.log('collapse show', collapse);
                        // collapse.show();
                        // force show, this kinda overrides the dropdown behavior of toggling.
                        // Show what the results are while typing
                    });
                }
                console.log('search result', result);
                // result.body.values
                if (result.status == 200) {
                    // console.log('OK response from search endpoint', this.searchEndPoint);
                    result.text().then((text) => {
                        // console.log('search result text', text);
                        let last = this.requestPipeLine[this.requestPipeLine.length - 1];
                        console.log('last', last);
                        console.log('currentInputValue', this.currentInputValue);
                        console.log('---');
                        // if, at this moment, when the response returns, the latest entered value is the same as the current input value
                        if (last && last.value && last.value == this.currentInputValue) {
                            // parse
                            this.handleData(text);
                            this.requestPipeLine = []; // reset the request pipeline
                        }
                        if (this.placement === 'main') {
                            this.loadingState = '';
                        }
                    });
                } else {
                    // console.error('NOT OK from', this.searchEndPoint);
                }
            });
        }
    }

    /**
     * extract interesting data from xml structure
     * 
     * @param {*} text 
     */
    handleData(text) {
        // let structure = this.domParser.parseFromString(text, 'text/xml');
        // console.log('data structure:', structure);
        // if (text) {
        //     this.data = structure.querySelectorAll('title, encoded, wp\\:post_type'); // content, excerpt
        // }
        this.data = JSON.parse(text);
        console.log('parsed data', this.data);
    }

    /**
     * 
     * @returns DOMParser
    */
    createDomParser() {
        if (typeof window !== 'undefined' && typeof window.DOMParser !== 'undefined') {
            this.domParser = new window.DOMParser;
        }
        return this.domParser;
    }

    renderSearchResultItemSmall(result) {
        // console.log('renderSearchResultItem', result);
        return html`
        <li class="row"> 
            <a href="${result.post_permalink}" class="col col-12 pb-4 search-result-small force-contrasting">
                <div class="row">
                    <div class="col">
                        <smol>
                            <small class="truncate-at-line" data-truncate-at-line="2">
                             ${result.post_type}: ${result.post_title}
                            </small>
                        </smol>
                    </div>
                </div>
                <div class="row">
                    <div class="col hyphenate truncate-at-line" data-truncate-at-line="2">
                        ${this.renderPostSnippet(result)}
                    </div>
                    <div class="col ms-auto col-auto my-auto">
                        <svg class="svg-icon static-color svg-icon-hover svg-icon-size-20">
                            <title>Arrow right icon</title>
                            <use xlink:href="#icon-arrow-right"></use>
                        </svg>
                    </div>
                </div>
            </a>
        </li>
        `;
    }

    renderSearchResultItemSmol(result) {
        return this.renderSearchResultItemSmall(result);
    }


    renderSearchResultItemChonk(result) {
        return this.renderSearchResultItemLarge(result);
    }

    renderSearchResultItemLarge(result) {
        // console.log('renderSearchResultItem', result);
        return html`
        <li class="row"> 
            <a href="${result.post_permalink}" class="col col-12 search-result-large bg-${this.backgroundIdentifier}">
                <div class="row">
                    <div class="col">
                        <smol>
                            <small class="truncate-at-line" data-truncate-at-line="2">
                             ${result.post_type}: ${result.post_title}
                            </small>
                        </smol>
                    </div>
                </div>
                <h3 class="truncate-at-line" data-truncate-at-line="2">${result.post_title}</h3>
                <p class="truncate-at-line" data-truncate-at-line="4">
                     ${this.renderPostSnippet(result)} 
                </p>
                <hr class="mb-4" />
            </a>
        </li>
        `;
    }

    /**
     * Render a snippet based on array of content surrounding the term data
     * @param {*} result 
     * @returns 
     */
    renderPostSnippet(result) {
        let template = [];
        // result.post_snippet.forEach((part, index, array) => {
        //     template.push(html`${part}`);
        //     template.push(html`<mark>${this.data.term}</mark>`);
        // });

        result.post_snippet.forEach((snippetPart, index) => {
            // first item
            if (index == 0) {
                // do not prefix with term
                template.push(html`${snippetPart.content.prefix}`);
            }
            // subsequent items
            if (index > 0) {
                // prefix with term
                template.push(html`${snippetPart.content.prefix}<mark>${snippetPart.term}</mark>${snippetPart.content.affix}`);
            }
        });

        console.log('post snippet source array', result.post_snippet);

        // if (result.post_snippet.length == 1) {
        //     template.push(html`<mark>${this.data.term}</mark>`);
        //     template.push(html`${result.post_snippet[0]}`);
        //     // template.push(html` ... `);
        // }
        // if (result.post_snippet.length > 1) {
        //     template.push(html`<mark>${this.data.term}</mark>`);
        //     template.push(html`${result.post_snippet[1]}`);
        //     template.push(html` ... `);
        // }





        // result.post_snippet.forEach((part, index, array) => {
        //     template.push(html`<mark>${this.data.term}</mark>`);
        //     template.push(html`${part}`);
        // });
        // result.post_snippet.filter(function(item, index, snippetArray) {

        //     return 
        // });

        return template;
    }

    getBody() {
        let body = document.querySelector('body');
        return body;
    }

    connectedCallback() {
        super.connectedCallback();
        this.getSearchEndPoint();
        this.getSearchEndPointTranslated();
        this.handleTerm();
        this.handleUniversalResourceIdentifier();
        this.handleSyncResultSlot();
        // this.handleTranslationSlots();
    }

    firstUpdated() {
        document.documentElement.querySelector('body').addEventListener('click', (event) => {
            let closestSelf = event.target.closest(this.renderRoot.nodeName.toLowerCase())
            // console.log('closestSelf', closestSelf);
            if (closestSelf == null) {
                this.dropdowns.forEach((dropdown) => {
                    dropdown.hide();
                });
            }
            if (closestSelf) {
                if (this.data.results) {
                    this.dropdowns.forEach((dropdown) => {
                        dropdown.show();
                    });
                }
            }
        });
        if (this.flow == 'dropdown') {
            this.configureSearchDropdown(); // init & cache
        }
        if (this.flow == 'collapse') {
            this.configureSearchCollapse(); // init & cache
        }
        this.lineClampModule = new LineClampModule();
        this.renderRoot.addEventListener('mouseover', (event) => {
            console.log('[NexusSearchComponent]', this);
            // let t = new TextToSpeechModule();
            // t.initialize();
            // if (t.enabled) {
            //     t.speak('Je bent nu in het zoekcomponent van deze website. Voer nu je zoekterm in en bevestig je keuze.');
            // }
        });
    }

    handleTerm() {
        if (this.query) {
            this.term = new URLSearchParams(new URL(window.location.href).search).get('s');
            console.log('this term', this.term);
            if (this.term && this.term.length > 0) {
                // adapt to existing structure
                let _event = {
                    'target': {
                        'value': this.term // the text content of the term slot
                    }
                };
                this.handleSyncResultSlot();
                if (this.placement === 'main') {
                    this.loadingState = 'loading';
                }
                this.handleInput(_event);
            }
        }
    }

    handleTranslationSlots() {
        console.log('handleTranslationSlots');
    }

    handleUniversalResourceIdentifier() {
        let uri = this.closest('form').action;
        console.log('uri', uri);
        if (uri) {
            this.uri = uri.textContent;
        }
    }

    handleSyncResultSlot() {
        this.syncResultSlot = this.getSlotContent('sync-result');
    }

    getSlotContent(slotName) {
        let s = this.renderRoot.querySelector(`slot[name="${slotName}"]`);
        if (this.debugMode === true && !s) {
            console.warn(`no ${slotName} slot found`);
        }
        if (s) {
            console.log('slot content of slot', slotName, 'is', s);
        }
        return s;
    }

    getTemplateContent(identifier) {
        let t = this.renderRoot.querySelector(`#${identifier}`);
        // console.log('t ---', t);
        if (t && t.textContent) {
            // console.log('html - template content of', identifier, 'is', t.textContent);
            return t.textContent;
        }
        return null;
    }

    getTemplateContentForAttribute(identifier) {
        let t = this.renderRoot.querySelector(`[id="${identifier}"]`);
        if (t && t.textContent) {
            // console.log('attribute - template content of', identifier, 'is', t.textContent);
            return t.textContent;
        }
        return null;
    }

    getSearchEndPoint() {
        let searchEndPointElement = this.querySelector('.endpoint');
        if (searchEndPointElement) {
            console.log('searchEndPoint', searchEndPointElement.innerHTML, searchEndPointElement);
            this.searchEndPoint = searchEndPointElement.innerHTML;
            return this.searchEndPoint;
        }
        return null;
    }

    getSearchEndPointTranslated() {
        let languageModule = new DocumentLanguageModule();
        let language = languageModule.guessLanguageFromUri();
        if (language === null) {
            language = languageModule.guessLanguageFromHtmlLanguage();
        }
        console.log('language...', language);
        if (language === 'en') {
            let searchEndPointElement = this.querySelector('.endpoint-translated');
            if (searchEndPointElement) {
                console.log('searchEndPointTranslated', searchEndPointElement.innerHTML, searchEndPointElement);
                this.searchEndPoint = searchEndPointElement.innerHTML;
                return this.searchEndPoint;
            }
        }
        return null;
    }

    configureSearchDropdown() {
        const dropdownElementList = this.renderRoot.querySelectorAll('.dropdown-toggle');
        console.log('[NexusSearchComponent] configureSearchDropdown', dropdownElementList);
        let dropdownList = [...dropdownElementList].forEach((toggleElement) => {
            this.dropdowns.push(new bootstrap.Dropdown(toggleElement, {
            }));
            // console.log('now dropdowns are', this.dropdowns);
        });
        this.dropdowns.forEach((dropdown) => {
            console.log('dropdown...', dropdown._element);
        });
        this.dropdowns.forEach((dropdown) => {
            dropdown._element.addEventListener('hidden.bs.dropdown', (event) => {
                // when the dropdown closes, remove the wide class
                console.log('dropdown', dropdown, 'was hidden');
                this.dropdownState = 'hidden';
                this.requestUpdate();
                this.data = {};
            });
        });
        this.dropdowns.forEach((dropdown) => {
            dropdown._element.addEventListener('shown.bs.dropdown', (event) => {
                // when the dropdown closes, remove the wide class
                console.log('dropdown', dropdown, 'was shown', this);
                this.dropdownState = 'shown';
                this.requestUpdate();
            });
        });
    }

    configureSearchCollapse() {
        const collapseElementList = this.renderRoot.querySelectorAll('.collapse');
        console.log('[NexusSearchComponent] configureSearchCollapse', collapseElementList);
        let collapseList = [...collapseElementList].forEach((collapseElement) => {
            this.collapses.push(new bootstrap.Collapse(collapseElement, {
                toggle: false,
            }));
            // console.log('now collapses are', this.collapses);
        });
        this.collapses.forEach((collapse) => {
            console.log('collapse...', collapse._element);
            // collapse.hide();
        });
        this.collapses.forEach((collapse) => {
            collapse._element.addEventListener('hidden.bs.collapse', (event) => {
                // when the collapse closes, remove the wide class
                // console.log('collapse', collapse, 'was hidden');
                // this.renderRoot.classList.remove('wide');
                this.collapseState = 'hidden';
                this.data = {};
                this.requestUpdate();
            });
        });
        this.collapses.forEach((collapse) => {
            collapse._element.addEventListener('shown.bs.collapse', (event) => {
                // when the collapse closes, remove the wide class
                // console.log('collapse', collapse, 'was shown', this);
                // this.renderRoot.classList.add('wide');
                this.collapseState = 'shown';
                this.requestUpdate();
            });
        });
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return html`
            ${this.doRender()}            
            `;
    }


}
window.customElements.define('nexus-search', NexusSearchComponent);
